<template>
  <v-dialog v-model="showDialog" width="400" :fullscreen="$mq === 'xs'">
    <v-card :tile="$mq === 'xs'">
      <v-card-title class="blue darken-2 white--text">
        <h2 class="text-h4 mb-1 mx-auto">
          Gift Recipient Details
        </h2>
      </v-card-title>
      <v-card-text class="pt-6 pb-8">
        <v-form>
          <TextCopiable
            :text="_get(order, 'gift_details_object.first_name')"
            label="First Name"
          />
          <TextCopiable
            :text="_get(order, 'gift_details_object.last_name')"
            label="Last Name"
          />
          <TextCopiable
            :text="_get(order, 'gift_details_object.email')"
            label="Email"
          />
          <TextCopiable
            :text="_get(order, 'gift_details_object.phone')"
            label="Phone"
          />
          <TextCopiable
            :text="_get(order, 'delivery_address')"
            label="Delivery Address"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer />
        <BtnBaseBlue
          @click="$emit('close')"
          depressed
          class="white--text"
          color="blue darken-2"
          large
          >Close</BtnBaseBlue
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnBaseBlue from '@/components/BtnBaseBlue'
import TextCopiable from '@/components/TextCopiable'
import _get from 'lodash/get'
export default {
  name: 'DialogGifteeDetails',
  components: { BtnBaseBlue, TextCopiable },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    showDialog: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('change', val)
      },
    }, // showDialog
  },
  methods: {
    _get,
  },
}
</script>
